module.exports = function() {
  return new Worker(__webpack_public_path__ + "d4c32d430b1782fe8479.worker.js");
};